module.exports = __webpack_public_path__ + "static/media/teaser-geldwaeschereiquiz.3e6c5e21.jpg";